<script>
import * as moment from 'moment'
import { calculateArea } from '@/lib/services/coordinates';
import InteractiveMap from '@/components/InteractiveMap.vue';

export default {
  components: {
    InteractiveMap,
  },

  props: {
    farm: { type: Object, required: true },
    grazings: { type: Array, required: true },
    selectedGrazingId: { type: String },
  },

  data: () => ({
    startingPoint: undefined,
    polygons: [],
  }),

  watch: {
    selectedGrazingId(to, from) {
      this.readdPolygons();
    },
  },

  methods: {
    onMapInitialized(startingPoint) {
      this.startingPoint = [startingPoint.lat, startingPoint.lon];

      this.readdPolygons();
    },

    readdPolygons() {
      this.polygons.splice(0, this.polygons.length);
      (this.grazings || []).forEach(grazing => {
        this.polygons.push({
          id: grazing.id,
          points: grazing.perimeter_points,
          color: this.$store.getters['grazing/getGrazingColor'](grazing, this.farm),
          popup: this.getGrazingPopup(grazing),
          isSelected: this.selectedGrazingId && this.selectedGrazingId === grazing.id,
        });
      });
    },

    getGrazingPopup(grazing) {
      let grazingHref = this.$router.resolve({ name: 'grazing/single-grazing', params: { farmId: this.farm.id, grazingId: grazing.id } }).href;
      let area = calculateArea(grazing.perimeter_points, this.farm.units.area);
      return '' +
        `<div>Camp: ${grazing.camp_name || '[NO CAMP NAME]'}</div>` +
        `<div>Time In: ${grazing.time_in ? moment(grazing.time_in).format('YYYY-MM-DD HH:mm') : '-'}</div>` +
        `<div>Time Out: ${grazing.time_out ? moment(grazing.time_out).format('YYYY-MM-DD HH:mm') : '-'}</div>` +
        `<div>Area: ${area.toFixed(4)} ${this.farm.units.area}</div>` +
        `<div><a class="btn btn-outline-primary btn-block" style="margin-top:10px;" href="${grazingHref}">Open Grazing</a> </div>`;
    },
  },
}
</script>

<template>
  <div>
    <interactive-map
      :polygons="polygons"
      @initialized="onMapInitialized($event)"
      style="height:500px;" />
  </div>
</template>



// WEBPACK FOOTER //
// src/grazing/components/FarmMap.vue